import { useRiskMatrix } from "../../lib/queries";
import type { RiskMatrixEntry, Severity } from "../../types/api";

const CONS = ["Insignificant", "Minor", "Moderate", "Major", "Catastrophic"];
const LIKE = ["Rare", "Unlikely", "Possible", "Likely", "Almost Certain"];

export default function RiskMatrix({
  value,
  onSelect,
}: {
  value: { consequence: string; likelihood: string } | null;
  onSelect: (e: { consequence: string; likelihood: string; severity_class: Severity }) => void;
}) {
  const { data } = useRiskMatrix();
  const grid = new Map<string, RiskMatrixEntry>();
  (data ?? []).forEach((e) => grid.set(`${e.consequence}|${e.likelihood}`, e));

  return (
    <div>
      <div className="mb-2 flex gap-[3px]">
        <div className="w-20" />
        {LIKE.map((l) => (
          <div key={l} className="flex-1 text-center text-[9px] text-slatey">
            {l}
          </div>
        ))}
      </div>
      {CONS.map((c) => (
        <div key={c} className="mb-[3px] flex items-center gap-[3px]">
          <div className="w-20 text-right text-[9px] text-slatey">{c}</div>
          {LIKE.map((l) => {
            const cell = grid.get(`${c}|${l}`);
            const active = value?.consequence === c && value?.likelihood === l;
            return (
              <button
                key={l}
                onClick={() =>
                  cell && onSelect({ consequence: c, likelihood: l, severity_class: cell.severity_class })
                }
                className="flex-1 rounded-[3px] py-2 text-center transition"
                style={{
                  background: cell ? `${cell.color}${active ? "" : "33"}` : "transparent",
                  outline: active ? `2px solid ${cell?.color}` : "none",
                }}
                title={cell ? cell.severity_class : ""}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}
